<template>
  <div class="row m-2">
    <div class="col-xl-8 col-12 order-2 order-xl-1">
      <section-rfq
        :data="dataRFQ"
        @updateModelItem="handleUpdateModelRFQ"
      ></section-rfq>
      <section-rfq-2
        :rfqid="dataRFQ.rfqid"
        :customerID="customerID"
        :moduleName="moduleName"
      ></section-rfq-2>
    </div>
    <div class="col-xl-4 col-12 order-1 order-xl-2 vb-xl">
      <info-data-rfq
        :data="dataRFQ"
      >
      </info-data-rfq>
      <info-parts-new
        v-show="!isCreatingPO"
        :listRFQ2="listRFQ2"
        :listDataPO="listDataPO"
      ></info-parts-new>
    </div>
  </div>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'

export default {
  name: 'Index',
  mixins: [ routeEditLogic ],
  components: {
    'section-rfq': () => import(/* webpackChunkName: 'RFQPurchase' */ './SectionRFQ/Index.vue'),
    'section-rfq-2': () => import(/* webpackChunkName: 'RFQPurchase' */ './SectionRFQ2/Index.vue'),
    'info-parts-new': () => import(/* webpackChunkName: 'RFQPurchase' */ './InfoParts.vue'),
    'info-data-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ')
  },
  props: {
    moduleName: {
      type: String,
      required: true
    }
  },
  computed: {
    dataRFQ () {
      return this.$store.state[this.moduleName].dataRFQ
    },
    customerID () {
      return this.dataRFQ && this.dataRFQ.customerCompanyID
    },
    isCreatingPO () {
      return this.$store.state[this.moduleName].isCreatingPO
    },
    listRFQ2 () {
      return this.$store.state[this.moduleName].listRFQ2
    },
    mapListRFQ2 () {
      return this.$store.getters[`${this.moduleName}/fullDataRFQ`]
    },
    listDataPO () {
      return this.$store.state[this.moduleName].listDataPO
    },
    mapListDataPO () {
      return this.$store.getters[`${this.moduleName}/mapListDataPO`]
    }
  },
  methods: {
    handleUpdateModelRFQ (value) {
      this.$store.commit(`${this.moduleName}/UPDATE`, { key: 'dataRFQ', value })
    },
    // MIX
    mixHookState ({ value }) {
      this.$store.dispatch(`${this.moduleName}/resetState`)
      this.$nextTick(() => {
        this.$store.dispatch(`${this.moduleName}/loadData`, value)
      })
    },
    mixHookReset () {
      this.$store.dispatch(`${this.moduleName}/resetState`)
    }
  }
}
</script>
